export type TransactionItemDetailOptionsColumn = {
  id: string;
  code: string;
  label: string;
  priority: number;
  is_visible: boolean;
};

export enum TransactionDetailOptionDrawerMode {
  EDIT_MODE = 'edit',
  ADD_MODE = 'add',
}

export type TransactionDetailOptionFormType = {
  code: string;
  label: string;
  priority: number;
  is_visible: boolean;
};

export type TransactionItemDetailFormType = {
  label: string;
  is_visible: boolean;
  tooltip_message: string;
};
